import React, { useContext, useState } from "react";
import { FormDialog } from "components/common_components/Dialogs";
import Grid from "@material-ui/core/Grid";
import { Form as FormikForm, TextField } from "components/common_components/Formik";
import * as Yup from "yup";
import AppContext from "AppContext";
import { useSelector } from "react-redux";
import { Avatar } from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
        fontSize: "1rem",
    },
}));

function AuthRequiredDialog({ open, onClose, onAuthenticated }) {
    const classes = useStyles();
    const { user } = useSelector((state) => state.Login);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {
        api: { Login },
    } = useContext(AppContext);

    const validationSchema = Yup.object({
        password: Yup.string().required("Required field"),
    });

    async function onSubmitHandler({ password }, { setSubmitting, setErrors }) {
        setSubmitting(true);
        setIsSubmitting(true);
        Login.doLogin({
            email: user.email,
            password,
            onSuccess: () => {
                setSubmitting(false);
                setIsSubmitting(false);
                onAuthenticated();
                onClose();
            },
            onError: (error) => {
                setSubmitting(false);
                setIsSubmitting(false);
                setErrors({ password: error });
            },
        });
    }

    return (
        <FormDialog
            open={open}
            onClose={onClose}
            primaryButtonText="Authenticate"
            title={
                <div className={classes.title}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Password Required
                    </Typography>
                </div>
            }
            isSubmitting={isSubmitting}
            formId="auth-required-dialog-form"
        >
            {open && (
                <FormikForm
                    id="auth-required-dialog-form"
                    onSubmit={onSubmitHandler}
                    validateOnChange={false}
                    initialValues={{ password: "" }}
                    validationSchema={validationSchema}
                    showButtons={false}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField type="password" fieldName="password" label="Password *" autoFocus />
                        </Grid>
                    </Grid>
                </FormikForm>
            )}
        </FormDialog>
    );
}

export default AuthRequiredDialog;
